import React from 'react';
import { Card, Typography, Space, Steps } from 'antd';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

const CheckOutInstructions = () => {
  const { t } = useTranslation();
  
  return (
    <Card title={t('checkout.title')} style={{ marginBottom: '24px' }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Paragraph>
          <strong>{t('checkout.checkoutTime')}</strong>
        </Paragraph>
        <Paragraph>
          {t('checkout.intro')}
        </Paragraph>
        
        <Steps
          direction="vertical"
          current={-1}
          items={[
            {
              title: t('checkout.steps.time.title'),
              description: (
                <Paragraph>
                  {t('checkout.steps.time.description')}
                </Paragraph>
              ),
            },
            {
              title: t('checkout.steps.keys.title'),
              description: (
                <Paragraph>
                  {t('checkout.steps.keys.description')}
                </Paragraph>
              ),
            },
            {
              title: t('checkout.steps.locking.title'),
              description: (
                <Paragraph>
                  {t('checkout.steps.locking.description')}
                </Paragraph>
              ),
            },
            {
              title: t('checkout.steps.tidying.title'),
              description: (
                <Paragraph>
                  <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
                    <li>{t('checkout.steps.tidying.description').split('.')[0]}.</li>
                    <li>{t('checkout.steps.tidying.description').split('.')[1]}.</li>
                  </ul>
                </Paragraph>
              ),
            },
          ]}
        />
        
        <Paragraph style={{ marginTop: 16 }}>
          {t('checkout.goodbye')}
        </Paragraph>
      </Space>
    </Card>
  );
};

export { CheckOutInstructions };
